import React, {useEffect, useState} from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import {FormattedMessage} from "react-intl";
import paymentReportApi from '@api/payment-report'
import PurchasesReportSearch from '@components/payments/gateways/item/Search';
import ReportsChart from '@components/payments/gateways/item/Chart';
import ReportList from '@components/payments/gateways/item/List';
import whitListData from "../../hocs/withListData";
import withPaginationComponent from "../../hocs/withPaginationComponent";
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";



function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
  }
}

function PaymentsReportTypesPage(props) {
  const { data, isFetched, search} = props;
  const {gateway} = props.match.params
  
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <PurchasesReportSearch search={search}/>
        </Card>
      </Col>
      <Col span={24}>
        {data.length > 0 && <ReportsChart gateway={gateway} data={data}/>}
        
        <ReportList
          loading={!isFetched}
          data={data}/>
      </Col>
    </Row>
  )
}


export default whitListData(
  withPaginationComponent(PaymentsReportTypesPage),
  {
    fetchRequest: paymentReportApi.getGatewayReport,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);

